import { Button } from "react-bootstrap";
/**
 * @typedef {Object} TableErrorProps
 * @property {string} error
 * @property {function} handleRefresh
 * @property {boolean} loading
 */

/**
 * @param {TableErrorProps} param
 */

const TableError = ({ error, handleRefresh, loading }) => {
  return (
    <div>
      <div className="alert alert-danger mt-3" role="alert">
        <div className="d-flex justify-content-between align-items-center">
          <span>{error}</span>
          <Button
            variant="danger"
            size="sm"
            onClick={handleRefresh}
            disabled={loading}
            className="d-flex align-items-center gap-2"
          >
            <i
              className={`bi bi-arrow-clockwise ${loading ? "spinner-rotate" : ""}`}
            ></i>
            Retry
          </Button>
        </div>
      </div>
    </div>
  );
};
export default TableError;

